import { FilePreview } from '../FilePreview'

import * as styles from './FilePreviewContainer.module.css'

function FilePreviewContainer({
  Component = FilePreview,
  className = styles.FilePreviewContainer,
  downloadFileDocument,
  file,
  getFileById,
  scope,
  subject,
}) {
  return (
    <figure className={className}>
      <Component
        downloadFileDocument={downloadFileDocument}
        file={file}
        getFileById={getFileById}
        scope={scope}
        subject={subject}
      />
    </figure>
  )
}

export default FilePreviewContainer
